import { Show, type Component } from "solid-js";

interface Props {
  name: string;
  logoUrl?: string;
  color: string;
  compact?: boolean;
}

const Brand: Component<Props> = (props) => (
  <div class="brand-lockup" classList={{ compact: props.compact }}>
    <Show
      when={props.logoUrl}
      fallback={
        <div class="brand-mark" style={{ background: props.color }}>
          <span />
          <span />
        </div>
      }
    >
      <img class="brand-logo" src={props.logoUrl} alt={`${props.name} logo`} />
    </Show>
    <Show when={!props.logoUrl || !props.compact}>
      <span class="brand-name">{props.name}</span>
    </Show>
  </div>
);

export default Brand;

